import type { PaymentStatus, SalesOrderStatus } from '@/lib/api/sales-order-api'

// Luật sửa đơn — phản chiếu backend (useCase.Update / itemsEditable / infoEditable):
//   - Sản phẩm/vật tư (items, packaging, chiết khấu tổng) chỉ sửa được khi đơn
//     còn ở bước đầu vòng đời: draft, new hoặc awaiting_packaging.
//   - Thông tin chung (KH, giao hàng, ghi chú, cước, COD) sửa được khi đơn CHƯA
//     rời kho đi giao (trước in_delivery) VÀ chưa thanh toán (unpaid).
const ITEMS_EDITABLE_STATUSES: ReadonlySet<SalesOrderStatus> = new Set([
    'draft',
    'new',
    'awaiting_packaging',
])

const INFO_EDITABLE_STATUSES: ReadonlySet<SalesOrderStatus> = new Set([
    'draft',
    'new',
    'confirmed',
    'stock_out',
    'ready_to_deliver',
    'awaiting_packaging',
])

/** Sản phẩm/vật tư của đơn có được phép sửa không. */
export function canEditOrderItems(status: SalesOrderStatus): boolean {
    return ITEMS_EDITABLE_STATUSES.has(status)
}

/** Thông tin chung của đơn (KH, giao hàng, ghi chú...) có được phép sửa không. */
export function canEditOrderInfo(
    status: SalesOrderStatus,
    paymentStatus: PaymentStatus,
): boolean {
    return INFO_EDITABLE_STATUSES.has(status) && paymentStatus === 'unpaid'
}

/** Có nên hiện nút "Sửa" đơn không — khi bất kỳ nhóm nào sửa được. */
export function canEditOrder(
    status: SalesOrderStatus,
    paymentStatus: PaymentStatus,
): boolean {
    return canEditOrderItems(status) || canEditOrderInfo(status, paymentStatus)
}
